export default function Autocomplete(theme) {
  return {
    MuiAutocomplete: {
      styleOverrides: {
        paper: {
          boxShadow: theme.customShadows.dropdown,
          border: `1px solid ${theme.palette.grey[200]}`,
          borderRadius: 8,
        },
      },
    },
  };
}
